import { PilotStatusState } from './reducers';
export const getPilotStatus = ({ pages: { pilotStatus } }) => pilotStatus as PilotStatusState;
